import { Link } from "react-router-dom";
import Button from "components/Button";
import React from "react";
import {
  SectionDetail,
  SectionTag,
  SectionTitle,
} from "components/SectionContent";

export default function SocialRevolution() {
  return (
    <div className="relative px-4 pb-8 lg:pb-16 pt-8 lg:pt-[100px]  xl:pt-[100px] xxl:pt-[130px]">
      <div className="relative mx-auto max-w-[1800px] px-4">
        <div className="relative max-w-[1334px] mx-auto text-center z-10">
          <SectionTag text="Discover your Maian" />
          <SectionTitle
            text="Join the Social Revolution with Maians"
            highligh
          />

          <div className="max-w-[932px] mx-auto">
            <SectionDetail text="Discover the unparalleled possibilities of Maians in customization, secure digital identity, and brand engagement. Built on Vanar Chain’s robust blockchain technology, Maians revolutionize self-expression and identity." />

            <p className="text-sm lg:text-xl font-medium leading-2 lg:leading-7 ">
              Embrace the future of online interaction and identity with Maians.
            </p>
          </div>
        </div>

        <div className="relative flex align-center justify-center mt-8 lg:mt-[50px]">
          <Link to="/comingsoon">
            <Button
              className="primary-button glow p-[20px] lg:p-[24px] hover:shadow-3xl hover:shadow-lime"
              rightIcon
              text="Discover Your Maian"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}
